import DateFilter from '@/components/date-filter';
import $ from 'jquery'

export default {
    name: "Entre",
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            fields: ["num", "date", "articles"],
            filter: "",
            perPage: 10,
            currentPage: 1,
            is_loading: true,
            is_empty: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',
            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
        };
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }

        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
            }
            this.current_date_filter = data
            this.getListeEntres(data)
            this.is_month = true
        },
    },

    computed: {
        filtrage_entre_date() {
            return this.$store.getters["filtrage_entre_date"];
        },

        len_liste_entre() {
            return this.filtrage_entre_date.length;
        },
    },

    mounted() {
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.getListeEntres(data); // Affiche la liste des entres

    },

    methods: {
        filterDate() {
            const data = {
                date: this.filter_date,
            };
            this.$store.dispatch("filterDateEntre", data);
        },

        getListeEntres(data) {
            this.is_loading = true;

            this.$store.dispatch("getFiltrage_entre_date", data).then(() => {
                if (this.filtrage_entre_date.length > 0) {
                    this.is_empty = false;
                } else {
                    this.is_empty = true;
                }
                this.is_loading = false;
            });
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getListeEntres(data)
        },
    },
};


